<template>
    <div>
        <header class="qf-header mb-5 py-5">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col">
                        <router-link to="/">
                            <img src="../../assets/img/logo.png" alt="TM Smart" class="img-fluid">
                        </router-link>
                    </div>
                    <div class="col text-center text-sm-right">
                        <a href="#!" @click.prevent v-scroll-to="'#plans'"
                           class="qf-white-link">{{$ml.get('sign_up')}}</a>
                        <router-link to="/login" class="btn btn-outline-light ml-2 px-4">
                            {{$ml.get('log_in')}}
                        </router-link>
                    </div>
                </div>
            </div>
        </header>

        <div class="container">
            <div class="row mb-3" id="dateschutz">
                <div class="col-12">
                    <h4 id="datenschutz" class="text-uppercase mb-0 qf-dot-before">
                        <strong>
                            Datenschutz
                        </strong>
                    </h4>
                </div>
                <div class="col-12">
                    <hr class="qf-orange-separator mt-0">
                </div>
                <div class="col-12">
                    <p>
                        Oh and soon after that, I managed to get Zen Master Archaeologist. At some point, one of these
                        ‘expert analysts’ is going to mention that, perhaps, in order to make money in the gaming
                        sector, you might want to try making a good game, right? And I’m still playing EQ2 here and
                        there and looking forward to Vanguard’s f2p move set for some time in August. Don’t capture the
                        South GY unless you know exactly what you are doing. I was accused earlier in the week of not
                        knowing what a gold sink is. The last beta weekend event is gone and, as mentioned above, we
                        still need to wait for one more month.
                    </p>
                    <p>
                        Oh and soon after that, I managed to get Zen Master Archaeologist. At some point, one of these
                        ‘expert analysts’ is going to mention that, perhaps, in order to make money in the gaming
                        sector, you might want to try making a good game, right? And I’m still playing EQ2 here and
                        there and looking forward to Vanguard’s f2p move set for some time in August. Don’t capture the
                        South GY unless you know exactly what you are doing. I was accused earlier in the week of not
                        knowing what a gold sink is. The last beta weekend event is gone and, as mentioned above, we
                        still need to wait for one more month.
                    </p>
                </div>
            </div>
            <div class="row mb-3" id="gdpr">
                <div class="col-12">
                    <h4 id="gdpr" class="text-uppercase mb-0 qf-dot-before">
                        <strong>
                            GDPR
                        </strong>
                    </h4>
                </div>
                <div class="col-12">
                    <hr class="qf-orange-separator mt-0">
                </div>
                <div class="col-12">
                    <p>
                        Oh and soon after that, I managed to get Zen Master Archaeologist. At some point, one of these
                        ‘expert analysts’ is going to mention that, perhaps, in order to make money in the gaming
                        sector, you might want to try making a good game, right? And I’m still playing EQ2 here and
                        there and looking forward to Vanguard’s f2p move set for some time in August. Don’t capture the
                        South GY unless you know exactly what you are doing. I was accused earlier in the week of not
                        knowing what a gold sink is. The last beta weekend event is gone and, as mentioned above, we
                        still need to wait for one more month.
                    </p>
                </div>
            </div>
            <div class="row mb-3" id="agp">
                <div class="col-12">
                    <h4 id="agb" class="text-uppercase mb-0 qf-dot-before">
                        <strong>
                            AGB
                        </strong>
                    </h4>
                </div>
                <div class="col-12">
                    <hr class="qf-orange-separator mt-0">
                </div>
                <div class="col-12">
                    <p>
                        Oh and soon after that, I managed to get Zen Master Archaeologist. At some point, one of these
                        ‘expert analysts’ is going to mention that, perhaps, in order to make money in the gaming
                        sector, you might want to try making a good game, right? And I’m still playing EQ2 here and
                        there and looking forward to Vanguard’s f2p move set for some time in August. Don’t capture the
                        South GY unless you know exactly what you are doing. I was accused earlier in the week of not
                        knowing what a gold sink is. The last beta weekend event is gone and, as mentioned above, we
                        still need to wait for one more month.
                    </p>
                </div>
            </div>


        </div>


    </div>
</template>

<script>
    export default {
        name: "InfoPage"
    }
</script>

<style scoped>
</style>